(function() {
  'use strict';
  angular.module('ringbaPortal').controller('LightDarkThemeToggleController', LightDarkThemeToggleController);

  function LightDarkThemeToggleController(
    userSettingsService
  ) {
    'ngInject';

    const vm = this;

    vm.onThemeChange = onThemeChange;

    function onThemeChange(isLightTheme) {
      if (vm.isUserPreference && typeof isLightTheme !== 'undefined') {
        _saveThemePreferenceToUserSettings(isLightTheme);
      }
    }

    function _saveThemePreferenceToUserSettings(isLightTheme) {
      userSettingsService.getUserSettings()
        .then(function(userSettings) {
          if (isLightTheme !== userSettings.isLightTheme) {
            userSettings.isLightTheme = isLightTheme;
            return userSettingsService.saveUserSettings(userSettings);
          }
        });
    }
    

  }
})();
